export default "__VITE_ASSET__43691e66__"